export default __webpack_public_path__ + "assets/670d8df510fbd299bc4c8560ca847c31.jpg";